import React from "react";

export default function MSAccess_Rnd() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Rnd</h1>
      <p>This is the MSAccess_Rnd component generated from the SQL JSON.</p>
    </div>
  );
}
